import { t } from 'i18next';
import { makeAutoObservable } from 'mobx';
import { IAxiosApiReducer, ResponseState } from 'reducers/AxiosApiReducer';
import { IResult } from 'services/Result';
import shortid from 'shortid';

type toastVariants = 'success' | 'error' | 'info';

export type singleNotificationType = {
  id?: any;
  response?: IAxiosApiReducer<any> | IResult<any>;
  // purpose : is for the key in the translation file... TODO : maybe change it to translationKey
  purpose?: string;
  variant: toastVariants;
  errorBag?: any;
  title?: string;
  message?: string;
  autoClose?: boolean;
};
export interface INotificationsStore {
  allNotifications: singleNotificationType[];
  displayNotification: ({ response, purpose, title, message, variant, autoClose }: singleNotificationType) => void;
  clearNotification: (id: string) => void;
}
export class NotificationsStore implements INotificationsStore {
  allNotifications: singleNotificationType[] = [];

  maxNotifications = 6;

  constructor() {
    makeAutoObservable(this);
  }

  displayNotification = async ({
    response,
    purpose = '',
    title = '',
    message = '',
    variant = 'info',
    autoClose = true,
  }: singleNotificationType) => {
    const id = shortid.generate();
    const isStatic = title || message;

    // below is because we receive different schemas from the backend
    const res = {
      responseState:
        (response?.['responseState'] && response?.['responseState'] === ResponseState.error) || response?.['exceptionType']
          ? ResponseState.error
          : ResponseState.success,
      message: response?.errorMessage || response?.data?.[0]?.message || '',
      httpStatus: response?.['httpStatus'] || response?.data?.[0]?.code || 0,
    };

    if (!res && !isStatic) return;

    const newNotification = {
      id,
      response,
      purpose,
      variant,
      title,
      message,
    };

    const errorBag = {
      name: 'error',
      title: isStatic ? title : `${t('error')} ${res?.httpStatus || ''}`,
      message: isStatic ? message : response?.errorMessage || t('toastMessages.failed_unknown_reason'),
    };

    this.allNotifications.push({
      ...newNotification,
      variant: isStatic ? variant : res?.responseState === ResponseState.success ? 'success' : 'error',
      ...(res?.responseState === ResponseState.error ? { errorBag } : {}),
    });

    // hide notification after 5 seconds if it is success message
    if (autoClose && (isStatic || res?.responseState === ResponseState.success)) {
      setTimeout(() => {
        this.clearNotification(id);
      }, 5000);
    }

    // if there are more than 6 notifications, remove the first one
    if (this.allNotifications.length > this.maxNotifications) this.allNotifications.shift();
  };

  clearNotification = (id: string) => {
    this.allNotifications = this.allNotifications.filter((n) => n.id !== id);
  };
}

export default NotificationsStore;
